import React from 'react';
import { COMPANY, NAV_LINKS, SERVICES, SOCIAL } from '../../data/siteData';

function TiktokIcon() {
  return <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.34 6.34 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.73a8.17 8.17 0 004.78 1.52V6.79a4.85 4.85 0 01-1.01-.1z"/></svg>;
}
function XIcon() {
  return <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.736-8.857L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>;
}
function TelegramIcon() {
  return <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M11.944 0A12 12 0 1 0 24 12 12 12 0 0 0 11.944 0zm5.992 8.265-1.978 9.316c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12L8.29 14.305l-2.96-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.9.298z"/></svg>;
}

export default function Footer() {
  const iconBtn = {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: '34px', height: '34px',
    background: 'rgba(201,168,76,0.08)',
    border: '1px solid rgba(201,168,76,0.2)',
    borderRadius: '8px', color: 'var(--gold)',
    textDecoration: 'none', transition: 'all 0.2s', flexShrink: 0,
  };

  return (
    <footer style={{ background: 'var(--ink-soft)', borderTop: '1px solid var(--gold-border)', padding: '56px 0 28px', width: '100%', overflow: 'hidden' }}>
      <div className="container">
        <div className="footer-grid">

          {/* Brand */}
          <div>
            <div style={{ fontFamily: 'var(--font-serif)', fontSize: '20px', fontWeight: 700, color: 'var(--gold)', marginBottom: '12px' }}>
              {COMPANY.name}
            </div>
            <p style={{ fontSize: '13px', color: 'var(--text-secondary)', lineHeight: 1.8, maxWidth: '280px', fontWeight: 300, marginBottom: '18px' }}>
              A full-service financial LLC offering investment advisory, asset management, and access to global markets.
            </p>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '18px', flexWrap: 'wrap' }}>
              {[
                { href: SOCIAL.tiktok, Icon: TiktokIcon },
                { href: SOCIAL.x, Icon: XIcon },
                { href: SOCIAL.telegram, Icon: TelegramIcon },
              ].map(({ href, Icon }, i) => (
                <a key={i} href={href} target="_blank" rel="noopener noreferrer" style={iconBtn}
                  onMouseEnter={e => e.currentTarget.style.background = 'rgba(201,168,76,0.2)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'rgba(201,168,76,0.08)'}
                ><Icon /></a>
              ))}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <a href={`mailto:${COMPANY.email}`} style={{ fontSize: '13px', color: 'var(--gold)', textDecoration: 'none' }}>{COMPANY.email}</a>
              <span style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>{COMPANY.address}</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h5 style={{ fontSize: '11px', letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '14px' }}>Services</h5>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {SERVICES.map(s => (
                <li key={s.id}>
                  <a href="#services" style={{ fontSize: '13px', color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }}
                    onMouseEnter={e => e.target.style.color = 'var(--gold)'}
                    onMouseLeave={e => e.target.style.color = 'var(--text-secondary)'}
                  >{s.title}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h5 style={{ fontSize: '11px', letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '14px' }}>Company</h5>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[...NAV_LINKS, { label: 'Books', href: '/books' }].map(l => (
                <li key={l.label}>
                  <a href={l.href} style={{ fontSize: '13px', color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }}
                    onMouseEnter={e => e.target.style.color = 'var(--gold)'}
                    onMouseLeave={e => e.target.style.color = 'var(--text-secondary)'}
                  >{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: '20px',
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px',
        }}>
          <p style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved. {COMPANY.registration}.
          </p>
          <p style={{ fontSize: '11px', color: 'var(--text-muted)', maxWidth: '360px', lineHeight: 1.6 }}>
            Trading involves risk. Past performance is not indicative of future results.
          </p>
        </div>
      </div>
    </footer>
  );
}
